module.exports = __webpack_public_path__ + "img/icon-modify.f4655cda.svg";